export default __webpack_public_path__ + "static/user_analysis-4d637ac545479c40ecfffb423b4f4356.png";